import {
	getResponsiveContentfulImageUrl,
	IImageOptions,
	IResponsiveImageSource,
} from '@/ui';
import { IImageAsset } from '../contentful';

export function getFeatureImageSource(
	image?: IImageAsset,
): IResponsiveImageSource {
	if (!image) {
		return '';
	}

	const { url } = image.fields.file;

	const options: IImageOptions = {
		fit: 'thumb',
	};

	return [
		getResponsiveContentfulImageUrl(url, { ...options, w: 50, h: 50 }),
		{
			mobile: getResponsiveContentfulImageUrl(url, {
				...options,
				w: 30,
				h: 30,
			}),
			mobileXL: getResponsiveContentfulImageUrl(url, {
				...options,
				w: 50,
				h: 50,
			}),
		},
	];
}
